function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 .2h22.9v3H0zM4.8 5.2h18.1v3H4.8zM2.6 10.1h20.3v3H2.6zM8.2 15h14.7v3H8.2zM1.8 20h21.1v3H1.8z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22.9 22.9"
  }, props), _ref);
};

export default SvgComponent;